// PRE RMA — Mémoire locale des périodes ouvertes (id, mois, statut) : ouvrir un mois déjà visité fonctionne SANS connexion.
// (La création d'un NOUVEAU mois, elle, se fait côté serveur : c'est pourquoi le mois suivant est préparé d'avance quand le réseau est là.)
import type { Periode } from '../pages/Accueil.tsx';

const CLE = 'prerma_periodes_v1';
type Carte = Record<string, Periode>;
const lire = (): Carte => { try { return JSON.parse(localStorage.getItem(CLE) ?? '{}') as Carte; } catch { return {}; } };
const cle = (annee: number, mois: number) => `${annee}-${mois}`;

export function memoriserPeriode(p: Periode) {
  const c = lire(); c[cle(p.annee, p.mois)] = p;
  const entrees = Object.entries(c).sort((a, b) => (a[0] < b[0] ? 1 : -1)).slice(0, 36); // 3 ans max
  localStorage.setItem(CLE, JSON.stringify(Object.fromEntries(entrees)));
}
export const periodeConnue = (annee: number, mois: number): Periode | null => lire()[cle(annee, mois)] ?? null;
export function periodeVoisine(p: Pick<Periode, 'annee' | 'mois'>, delta: -1 | 1): Periode | null {
  let m = p.mois + delta, a = p.annee;
  if (m < 1) { m = 12; a -= 1; } else if (m > 12) { m = 1; a += 1; }
  return periodeConnue(a, m);
}
export const oublierPeriodes = () => localStorage.removeItem(CLE);
